import { FileGroupItemDto } from 'api/risk';
import { useAsyncResource } from 'back-office/shared/hooks/useAsyncResource';
import { useCallback } from 'react';
import { risksAPI } from 'services/swagger-api/riskApi';

/**
 * Files created together with a file (the legal protection file "for the company" and the one
 * "for the manager"), for the file selector of the contractualisation page.
 * Empty while loading, on failure, without a file or when the file has no group.
 *
 * @param refreshKey changes when the contractualisation data of the page is reloaded, so the
 * statuses of the files follow.
 */
export const useFileGroup = (riskId?: string, refreshKey?: unknown): FileGroupItemDto[] => {
  const fetchFileGroup = useCallback(
    () => risksAPI.getDossiersGroupe({ risqueAssureId: riskId! }),
    // refreshKey only triggers the reload
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [riskId, refreshKey]
  );

  const { data } = useAsyncResource(fetchFileGroup, Boolean(riskId));

  return data?.items ?? [];
};
